<script>
import FeatureBox from './FeatureBox';

export default {
  extends: FeatureBox
};
</script>
